export const checkIsResponseSuccess = (status) => status >= 200 && status < 300;
//# sourceMappingURL=api.js.map